import React from "react";
import { AccordionItemDataProps } from "./accordionItem.component";

//
import "./accordion.component.scss";
import AccordionItem from "./accordionItem.component";

interface Props {
  headline: string;
  items: AccordionItemDataProps[];
}

const Accordion: React.FC<Props> = (props) => {
  const [activeIndex, setActiveIndex] = React.useState(-1);

  const closeItem = (key: any) => {
    setActiveIndex(activeIndex === key ? -1 : key);
  };

  return (
    <div className="accordion">
      <div className="accordion__wrapper">
        <div className="accordion__inner">
          <h3 className="accordion__headline">{props.headline}</h3>
          {props.items.map((item, key) => (
            <AccordionItem
              question={item.question}
              answer={item.answer}
              key={key}
              open={activeIndex === key}
              // onClick={() => setActiveIndex(activeIndex === key ? -1 : key)}
              onClick={() => closeItem(key)}
              index={key + 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
